import { $t } from '@previo/core'
import { Country } from '../country/Country'
import { Codebook } from '../Codebook'
import type { CountryId } from '../country/CountryId'
import { AddressIdentificationId } from './AddressIdentificationId'

export type AddressIdentificationOption = {
  id: string
  name: string
  isNullOption?: boolean
}

export class AddressIdentification extends Codebook<AddressIdentificationId> {
  private constructor(
    public readonly id: AddressIdentificationId,
    public readonly name: () => string,
    public readonly identNumber: number,
    public readonly country: Country,
    public readonly options: AddressIdentificationOption[],
    public readonly isRequired: boolean,
  ) {
    super(id)
  }

  static readonly ID_CZE = new AddressIdentification(
    AddressIdentificationId.ID_CZE,
    () => $t('Company ID'),
    1,
    Country.CZE,
    [],
    true,
  )
  static readonly VAT_ID_CZE = new AddressIdentification(
    AddressIdentificationId.VAT_ID_CZE,
    () => $t('VAT ID'),
    2,
    Country.CZE,
    [],
    false,
  )
  static readonly ID_SVK = new AddressIdentification(
    AddressIdentificationId.ID_SVK,
    () => $t('Company ID'),
    1,
    Country.SVK,
    [],
    true,
  )
  static readonly VAT_ID_SVK = new AddressIdentification(
    AddressIdentificationId.VAT_ID_SVK,
    () => $t('VAT ID'),
    2,
    Country.SVK,
    [],
    false,
  )
  static readonly ID_AUT = new AddressIdentification(
    AddressIdentificationId.ID_AUT,
    () => $t('Company ID'),
    1,
    Country.AUT,
    [],
    false,
  )
  static readonly VAT_ID_AUT = new AddressIdentification(
    AddressIdentificationId.VAT_ID_AUT,
    () => $t('VAT ID'),
    2,
    Country.AUT,
    [],
    false,
  )
  static readonly VAT_ID_POL = new AddressIdentification(
    AddressIdentificationId.VAT_ID_POL,
    () => $t('VAT ID'),
    2,
    Country.POL,
    [],
    true,
  )
  static readonly ID_POL = new AddressIdentification(
    AddressIdentificationId.ID_POL,
    () => $t('Company ID'),
    1,
    Country.POL,
    [],
    false,
  )
  static readonly ID_GBR = new AddressIdentification(
    AddressIdentificationId.ID_GBR,
    () => $t('Company ID'),
    1,
    Country.GBR,
    [],
    false,
  )
  static readonly VAT_ID_GBR = new AddressIdentification(
    AddressIdentificationId.VAT_ID_GBR,
    () => $t('VAT ID'),
    2,
    Country.GBR,
    [],
    false,
  )
  static readonly ID_USA = new AddressIdentification(
    AddressIdentificationId.ID_USA,
    () => $t('Company ID'),
    1,
    Country.USA,
    [],
    false,
  )
  static readonly VAT_ID_USA = new AddressIdentification(
    AddressIdentificationId.VAT_ID_USA,
    () => $t('VAT ID'),
    2,
    Country.USA,
    [],
    false,
  )
  static readonly ID_SVN = new AddressIdentification(
    AddressIdentificationId.ID_SVN,
    () => $t('Company ID'),
    1,
    Country.SVN,
    [],
    false,
  )
  static readonly VAT_ID_SVN = new AddressIdentification(
    AddressIdentificationId.VAT_ID_SVN,
    () => $t('VAT ID'),
    2,
    Country.SVN,
    [],
    false,
  )
  static readonly VAT_ID_HUN = new AddressIdentification(
    AddressIdentificationId.VAT_ID_HUN,
    () => $t('VAT ID'),
    2,
    Country.HUN,
    [],
    false,
  )
  static readonly ID_HUN = new AddressIdentification(
    AddressIdentificationId.ID_HUN,
    () => $t('Company ID'),
    1,
    Country.HUN,
    [],
    false,
  )
  static readonly ID_FRA = new AddressIdentification(
    AddressIdentificationId.ID_FRA,
    () => $t('Company ID'),
    1,
    Country.FRA,
    [],
    false,
  )
  static readonly VAT_ID_FRA = new AddressIdentification(
    AddressIdentificationId.VAT_ID_FRA,
    () => $t('VAT ID'),
    2,
    Country.FRA,
    [],
    false,
  )
  static readonly ID_IDN = new AddressIdentification(
    AddressIdentificationId.ID_IDN,
    () => $t('Company ID'),
    1,
    Country.IDN,
    [],
    false,
  )
  static readonly VAT_ID_IDN = new AddressIdentification(
    AddressIdentificationId.VAT_ID_IDN,
    () => $t('VAT ID'),
    2,
    Country.IDN,
    [],
    false,
  )
  static readonly ID_UKR = new AddressIdentification(
    AddressIdentificationId.ID_UKR,
    () => $t('Company ID'),
    1,
    Country.UKR,
    [],
    false,
  )
  static readonly VAT_ID_UKR = new AddressIdentification(
    AddressIdentificationId.VAT_ID_UKR,
    () => $t('VAT ID'),
    2,
    Country.UKR,
    [],
    false,
  )
  static readonly ID_CHE = new AddressIdentification(
    AddressIdentificationId.ID_CHE,
    () => $t('Company ID'),
    1,
    Country.CHE,
    [],
    false,
  )
  static readonly VAT_ID_CHE = new AddressIdentification(
    AddressIdentificationId.VAT_ID_CHE,
    () => $t('VAT ID'),
    2,
    Country.CHE,
    [],
    false,
  )
  static readonly ID_ESP = new AddressIdentification(
    AddressIdentificationId.ID_ESP,
    () => $t('Company ID'),
    1,
    Country.ESP,
    [],
    false,
  )
  static readonly VAT_ID_ESP = new AddressIdentification(
    AddressIdentificationId.VAT_ID_ESP,
    () => $t('VAT ID'),
    2,
    Country.ESP,
    [],
    false,
  )
  static readonly ID_MAR = new AddressIdentification(
    AddressIdentificationId.ID_MAR,
    () => $t('Company ID'),
    1,
    Country.MAR,
    [],
    false,
  )
  static readonly VAT_ID_MAR = new AddressIdentification(
    AddressIdentificationId.VAT_ID_MAR,
    () => $t('VAT ID'),
    2,
    Country.MAR,
    [],
    false,
  )
  static readonly ID_MUS = new AddressIdentification(
    AddressIdentificationId.ID_MUS,
    () => $t('Company ID'),
    1,
    Country.MUS,
    [],
    false,
  )
  static readonly VAT_ID_MUS = new AddressIdentification(
    AddressIdentificationId.VAT_ID_MUS,
    () => $t('VAT ID'),
    2,
    Country.MUS,
    [],
    false,
  )
  static readonly ID_TUR = new AddressIdentification(
    AddressIdentificationId.ID_TUR,
    () => $t('Company ID'),
    1,
    Country.TUR,
    [],
    false,
  )
  static readonly VAT_ID_TUR = new AddressIdentification(
    AddressIdentificationId.VAT_ID_TUR,
    () => $t('VAT ID'),
    2,
    Country.TUR,
    [],
    false,
  )
  static readonly ID_IRL = new AddressIdentification(
    AddressIdentificationId.ID_IRL,
    () => $t('Company ID'),
    1,
    Country.IRL,
    [],
    false,
  )
  static readonly VAT_ID_IRL = new AddressIdentification(
    AddressIdentificationId.VAT_ID_IRL,
    () => $t('VAT ID'),
    2,
    Country.IRL,
    [],
    false,
  )
  static readonly ID_CHN = new AddressIdentification(
    AddressIdentificationId.ID_CHN,
    () => $t('Company ID'),
    1,
    Country.CHN,
    [],
    false,
  )
  static readonly VAT_ID_CHN = new AddressIdentification(
    AddressIdentificationId.VAT_ID_CHN,
    () => $t('VAT ID'),
    2,
    Country.CHN,
    [],
    false,
  )
  static readonly ID_DEU = new AddressIdentification(
    AddressIdentificationId.ID_DEU,
    () => $t('Company ID'),
    1,
    Country.DEU,
    [],
    false,
  )
  static readonly VAT_ID_DEU = new AddressIdentification(
    AddressIdentificationId.VAT_ID_DEU,
    () => $t('VAT ID'),
    2,
    Country.DEU,
    [],
    false,
  )
  static readonly ID_BGR = new AddressIdentification(
    AddressIdentificationId.ID_BGR,
    () => $t('Company ID'),
    1,
    Country.BGR,
    [],
    false,
  )
  static readonly VAT_ID_BGR = new AddressIdentification(
    AddressIdentificationId.VAT_ID_BGR,
    () => $t('VAT ID'),
    2,
    Country.BGR,
    [],
    false,
  )
  static readonly ID_NLD = new AddressIdentification(
    AddressIdentificationId.ID_NLD,
    () => $t('Company ID'),
    1,
    Country.NLD,
    [],
    false,
  )
  static readonly VAT_ID_NLD = new AddressIdentification(
    AddressIdentificationId.VAT_ID_NLD,
    () => $t('VAT ID'),
    2,
    Country.NLD,
    [],
    false,
  )
  static readonly ID_ITA = new AddressIdentification(
    AddressIdentificationId.ID_ITA,
    () => $t('Company ID'),
    1,
    Country.ITA,
    [],
    false,
  )
  static readonly VAT_ID_ITA = new AddressIdentification(
    AddressIdentificationId.VAT_ID_ITA,
    () => $t('VAT ID'),
    2,
    Country.ITA,
    [],
    false,
  )
  static readonly ID_BEL = new AddressIdentification(
    AddressIdentificationId.ID_BEL,
    () => $t('Company ID'),
    1,
    Country.BEL,
    [],
    false,
  )
  static readonly VAT_ID_BEL = new AddressIdentification(
    AddressIdentificationId.VAT_ID_BEL,
    () => $t('VAT ID'),
    2,
    Country.BEL,
    [],
    false,
  )
  static readonly VAT_ID_ROU = new AddressIdentification(
    AddressIdentificationId.VAT_ID_ROU,
    () => $t('VAT ID'),
    2,
    Country.ROU,
    [],
    false,
  )
  static readonly ID_ROU = new AddressIdentification(
    AddressIdentificationId.ID_ROU,
    () => $t('Company ID'),
    1,
    Country.ROU,
    [],
    false,
  )
  static readonly ID_LVA = new AddressIdentification(
    AddressIdentificationId.ID_LVA,
    () => $t('Company ID'),
    1,
    Country.LVA,
    [],
    false,
  )
  static readonly VAT_ID_LVA = new AddressIdentification(
    AddressIdentificationId.VAT_ID_LVA,
    () => $t('VAT ID'),
    2,
    Country.LVA,
    [],
    false,
  )
  static readonly ID_HRV = new AddressIdentification(
    AddressIdentificationId.ID_HRV,
    () => $t('Company ID'),
    1,
    Country.HRV,
    [],
    false,
  )
  static readonly VAT_ID_HRV = new AddressIdentification(
    AddressIdentificationId.VAT_ID_HRV,
    () => $t('VAT ID'),
    2,
    Country.HRV,
    [],
    false,
  )
  static readonly ID_GRC = new AddressIdentification(
    AddressIdentificationId.ID_GRC,
    () => $t('Company ID'),
    1,
    Country.GRC,
    [],
    false,
  )
  static readonly VAT_ID_GRC = new AddressIdentification(
    AddressIdentificationId.VAT_ID_GRC,
    () => $t('VAT ID'),
    2,
    Country.GRC,
    [],
    false,
  )
  static readonly ID_LTU = new AddressIdentification(
    AddressIdentificationId.ID_LTU,
    () => $t('Company ID'),
    1,
    Country.LTU,
    [],
    false,
  )
  static readonly VAT_ID_LTU = new AddressIdentification(
    AddressIdentificationId.VAT_ID_LTU,
    () => $t('VAT ID'),
    2,
    Country.LTU,
    [],
    false,
  )
  static readonly ID_AUS = new AddressIdentification(
    AddressIdentificationId.ID_AUS,
    () => $t('Company ID'),
    1,
    Country.AUS,
    [],
    false,
  )
  static readonly VAT_ID_AUS = new AddressIdentification(
    AddressIdentificationId.VAT_ID_AUS,
    () => $t('VAT ID'),
    2,
    Country.AUS,
    [],
    false,
  )
  static readonly ID_RUS = new AddressIdentification(
    AddressIdentificationId.ID_RUS,
    () => $t('Company ID'),
    1,
    Country.RUS,
    [],
    false,
  )
  static readonly VAT_ID_RUS = new AddressIdentification(
    AddressIdentificationId.VAT_ID_RUS,
    () => $t('VAT ID'),
    2,
    Country.RUS,
    [],
    false,
  )
  static readonly ID_MEX = new AddressIdentification(
    AddressIdentificationId.ID_MEX,
    () => $t('Company ID'),
    1,
    Country.MEX,
    [],
    false,
  )
  static readonly VAT_ID_MEX = new AddressIdentification(
    AddressIdentificationId.VAT_ID_MEX,
    () => $t('VAT ID'),
    2,
    Country.MEX,
    [],
    false,
  )
  static readonly ID_PRT = new AddressIdentification(
    AddressIdentificationId.ID_PRT,
    () => $t('Company ID'),
    1,
    Country.PRT,
    [],
    false,
  )
  static readonly VAT_ID_PRT = new AddressIdentification(
    AddressIdentificationId.VAT_ID_PRT,
    () => $t('VAT ID'),
    2,
    Country.PRT,
    [],
    false,
  )
  static readonly ID_BLR = new AddressIdentification(
    AddressIdentificationId.ID_BLR,
    () => $t('Company ID'),
    1,
    Country.BLR,
    [],
    false,
  )
  static readonly VAT_ID_BLR = new AddressIdentification(
    AddressIdentificationId.VAT_ID_BLR,
    () => $t('VAT ID'),
    2,
    Country.BLR,
    [],
    false,
  )
  static readonly ID_CAN = new AddressIdentification(
    AddressIdentificationId.ID_CAN,
    () => $t('Company ID'),
    1,
    Country.CAN,
    [],
    false,
  )
  static readonly VAT_ID_CAN = new AddressIdentification(
    AddressIdentificationId.VAT_ID_CAN,
    () => $t('VAT ID'),
    2,
    Country.CAN,
    [],
    false,
  )
  static readonly ID_EST = new AddressIdentification(
    AddressIdentificationId.ID_EST,
    () => $t('Company ID'),
    1,
    Country.EST,
    [],
    false,
  )
  static readonly VAT_ID_EST = new AddressIdentification(
    AddressIdentificationId.VAT_ID_EST,
    () => $t('VAT ID'),
    2,
    Country.EST,
    [],
    false,
  )
  static readonly ID_SRB = new AddressIdentification(
    AddressIdentificationId.ID_SRB,
    () => $t('Company ID'),
    1,
    Country.SRB,
    [],
    false,
  )
  static readonly VAT_ID_SRB = new AddressIdentification(
    AddressIdentificationId.VAT_ID_SRB,
    () => $t('VAT ID'),
    2,
    Country.SRB,
    [],
    false,
  )
  static readonly ID_DNK = new AddressIdentification(
    AddressIdentificationId.ID_DNK,
    () => $t('Company ID'),
    1,
    Country.DNK,
    [],
    false,
  )
  static readonly VAT_ID_DNK = new AddressIdentification(
    AddressIdentificationId.VAT_ID_DNK,
    () => $t('VAT ID'),
    2,
    Country.DNK,
    [],
    false,
  )
  static readonly ID_MKD = new AddressIdentification(
    AddressIdentificationId.ID_MKD,
    () => $t('Company ID'),
    1,
    Country.MKD,
    [],
    false,
  )
  static readonly VAT_ID_MKD = new AddressIdentification(
    AddressIdentificationId.VAT_ID_MKD,
    () => $t('VAT ID'),
    2,
    Country.MKD,
    [],
    false,
  )
  static readonly ID_SGP = new AddressIdentification(
    AddressIdentificationId.ID_SGP,
    () => $t('Company ID'),
    1,
    Country.SGP,
    [],
    false,
  )
  static readonly VAT_ID_SGP = new AddressIdentification(
    AddressIdentificationId.VAT_ID_SGP,
    () => $t('VAT ID'),
    2,
    Country.SGP,
    [],
    false,
  )
  static readonly ID_MDA = new AddressIdentification(
    AddressIdentificationId.ID_MDA,
    () => $t('Company ID'),
    1,
    Country.MDA,
    [],
    false,
  )
  static readonly VAT_ID_MDA = new AddressIdentification(
    AddressIdentificationId.VAT_ID_MDA,
    () => $t('VAT ID'),
    2,
    Country.MDA,
    [],
    false,
  )
  static readonly ID_ISR = new AddressIdentification(
    AddressIdentificationId.ID_ISR,
    () => $t('Company ID'),
    1,
    Country.ISR,
    [],
    false,
  )
  static readonly VAT_ID_ISR = new AddressIdentification(
    AddressIdentificationId.VAT_ID_ISR,
    () => $t('VAT ID'),
    2,
    Country.ISR,
    [],
    false,
  )
  static readonly ID_GNB = new AddressIdentification(
    AddressIdentificationId.ID_GNB,
    () => $t('Company ID'),
    1,
    Country.GNB,
    [],
    false,
  )
  static readonly VAT_ID_GNB = new AddressIdentification(
    AddressIdentificationId.VAT_ID_GNB,
    () => $t('VAT ID'),
    2,
    Country.GNB,
    [],
    false,
  )
  static readonly ID_ARM = new AddressIdentification(
    AddressIdentificationId.ID_ARM,
    () => $t('Company ID'),
    1,
    Country.ARM,
    [],
    false,
  )
  static readonly VAT_ID_ARM = new AddressIdentification(
    AddressIdentificationId.VAT_ID_ARM,
    () => $t('VAT ID'),
    2,
    Country.ARM,
    [],
    false,
  )
  static readonly ID_SWE = new AddressIdentification(
    AddressIdentificationId.ID_SWE,
    () => $t('Company ID'),
    1,
    Country.SWE,
    [],
    false,
  )
  static readonly VAT_ID_SWE = new AddressIdentification(
    AddressIdentificationId.VAT_ID_SWE,
    () => $t('VAT ID'),
    2,
    Country.SWE,
    [],
    false,
  )
  static readonly ID_FIN = new AddressIdentification(
    AddressIdentificationId.ID_FIN,
    () => $t('Company ID'),
    1,
    Country.FIN,
    [],
    false,
  )
  static readonly VAT_ID_FIN = new AddressIdentification(
    AddressIdentificationId.VAT_ID_FIN,
    () => $t('VAT ID'),
    2,
    Country.FIN,
    [],
    false,
  )
  static readonly ID_TWN = new AddressIdentification(
    AddressIdentificationId.ID_TWN,
    () => $t('Company ID'),
    1,
    Country.TWN,
    [],
    false,
  )
  static readonly VAT_ID_TWN = new AddressIdentification(
    AddressIdentificationId.VAT_ID_TWN,
    () => $t('VAT ID'),
    2,
    Country.TWN,
    [],
    false,
  )
  static readonly ID_LIE = new AddressIdentification(
    AddressIdentificationId.ID_LIE,
    () => $t('Company ID'),
    1,
    Country.LIE,
    [],
    false,
  )
  static readonly VAT_ID_LIE = new AddressIdentification(
    AddressIdentificationId.VAT_ID_LIE,
    () => $t('VAT ID'),
    2,
    Country.LIE,
    [],
    false,
  )
  static readonly ID_ISL = new AddressIdentification(
    AddressIdentificationId.ID_ISL,
    () => $t('Company ID'),
    1,
    Country.ISL,
    [],
    false,
  )
  static readonly VAT_ID_ISL = new AddressIdentification(
    AddressIdentificationId.VAT_ID_ISL,
    () => $t('VAT ID'),
    2,
    Country.ISL,
    [],
    false,
  )
  static readonly ID_SLV = new AddressIdentification(
    AddressIdentificationId.ID_SLV,
    () => $t('Company ID'),
    1,
    Country.SLV,
    [],
    false,
  )
  static readonly VAT_ID_SLV = new AddressIdentification(
    AddressIdentificationId.VAT_ID_SLV,
    () => $t('VAT ID'),
    2,
    Country.SLV,
    [],
    false,
  )
  static readonly ID_NGA = new AddressIdentification(
    AddressIdentificationId.ID_NGA,
    () => $t('Company ID'),
    1,
    Country.NGA,
    [],
    false,
  )
  static readonly VAT_ID_NGA = new AddressIdentification(
    AddressIdentificationId.VAT_ID_NGA,
    () => $t('VAT ID'),
    2,
    Country.NGA,
    [],
    false,
  )
  static readonly ID_MYS = new AddressIdentification(
    AddressIdentificationId.ID_MYS,
    () => $t('Company ID'),
    1,
    Country.MYS,
    [],
    false,
  )
  static readonly VAT_ID_MYS = new AddressIdentification(
    AddressIdentificationId.VAT_ID_MYS,
    () => $t('VAT ID'),
    2,
    Country.MYS,
    [],
    false,
  )
  static readonly ID_IND = new AddressIdentification(
    AddressIdentificationId.ID_IND,
    () => $t('Company ID'),
    1,
    Country.IND,
    [],
    false,
  )
  static readonly VAT_ID_IND = new AddressIdentification(
    AddressIdentificationId.VAT_ID_IND,
    () => $t('VAT ID'),
    2,
    Country.IND,
    [],
    false,
  )
  static readonly ID_ZAF = new AddressIdentification(
    AddressIdentificationId.ID_ZAF,
    () => $t('Company ID'),
    1,
    Country.ZAF,
    [],
    false,
  )
  static readonly VAT_ID_ZAF = new AddressIdentification(
    AddressIdentificationId.VAT_ID_ZAF,
    () => $t('VAT ID'),
    2,
    Country.ZAF,
    [],
    false,
  )
  static readonly ID_GHA = new AddressIdentification(
    AddressIdentificationId.ID_GHA,
    () => $t('Company ID'),
    1,
    Country.GHA,
    [],
    false,
  )
  static readonly VAT_ID_GHA = new AddressIdentification(
    AddressIdentificationId.VAT_ID_GHA,
    () => $t('VAT ID'),
    2,
    Country.GHA,
    [],
    false,
  )
  static readonly ID_KAZ = new AddressIdentification(
    AddressIdentificationId.ID_KAZ,
    () => $t('Company ID'),
    1,
    Country.KAZ,
    [],
    false,
  )
  static readonly VAT_ID_KAZ = new AddressIdentification(
    AddressIdentificationId.VAT_ID_KAZ,
    () => $t('VAT ID'),
    2,
    Country.KAZ,
    [],
    false,
  )
  static readonly ID_COK = new AddressIdentification(
    AddressIdentificationId.ID_COK,
    () => $t('Company ID'),
    1,
    Country.COK,
    [],
    false,
  )
  static readonly VAT_ID_COK = new AddressIdentification(
    AddressIdentificationId.VAT_ID_COK,
    () => $t('VAT ID'),
    2,
    Country.COK,
    [],
    false,
  )
  static readonly ID_PAK = new AddressIdentification(
    AddressIdentificationId.ID_PAK,
    () => $t('Company ID'),
    1,
    Country.PAK,
    [],
    false,
  )
  static readonly VAT_ID_PAK = new AddressIdentification(
    AddressIdentificationId.VAT_ID_PAK,
    () => $t('VAT ID'),
    2,
    Country.PAK,
    [],
    false,
  )
  static readonly VAT_ID_ADD_SVK = new AddressIdentification(
    AddressIdentificationId.VAT_ID_ADD_SVK,
    () => $t('VAT ID2'),
    3,
    Country.SVK,
    [],
    false,
  )
  static readonly ID_CRI = new AddressIdentification(
    AddressIdentificationId.ID_CRI,
    () => $t('Company ID'),
    1,
    Country.CRI,
    [],
    false,
  )
  static readonly ID_DOM = new AddressIdentification(
    AddressIdentificationId.ID_DOM,
    () => $t('Company ID'),
    1,
    Country.DOM,
    [],
    false,
  )
  static readonly VAT_ID_DOM = new AddressIdentification(
    AddressIdentificationId.VAT_ID_DOM,
    () => $t('VAT ID'),
    2,
    Country.DOM,
    [],
    false,
  )
  static readonly IDENT_CZE = new AddressIdentification(
    AddressIdentificationId.IDENT_CZE,
    () => $t('Ident.'),
    4,
    Country.CZE,
    [],
    false,
  )
  static readonly IDENT_AFG = new AddressIdentification(
    AddressIdentificationId.IDENT_AFG,
    () => $t('Ident.'),
    4,
    Country.AFG,
    [],
    false,
  )
  static readonly IDENT_ALB = new AddressIdentification(
    AddressIdentificationId.IDENT_ALB,
    () => $t('Ident.'),
    4,
    Country.ALB,
    [],
    false,
  )
  static readonly IDENT_DZA = new AddressIdentification(
    AddressIdentificationId.IDENT_DZA,
    () => $t('Ident.'),
    4,
    Country.DZA,
    [],
    false,
  )
  static readonly IDENT_ASM = new AddressIdentification(
    AddressIdentificationId.IDENT_ASM,
    () => $t('Ident.'),
    4,
    Country.ASM,
    [],
    false,
  )
  static readonly IDENT_VIR = new AddressIdentification(
    AddressIdentificationId.IDENT_VIR,
    () => $t('Ident.'),
    4,
    Country.VIR,
    [],
    false,
  )
  static readonly IDENT_AND = new AddressIdentification(
    AddressIdentificationId.IDENT_AND,
    () => $t('Ident.'),
    4,
    Country.AND,
    [],
    false,
  )
  static readonly IDENT_AGO = new AddressIdentification(
    AddressIdentificationId.IDENT_AGO,
    () => $t('Ident.'),
    4,
    Country.AGO,
    [],
    false,
  )
  static readonly IDENT_AIA = new AddressIdentification(
    AddressIdentificationId.IDENT_AIA,
    () => $t('Ident.'),
    4,
    Country.AIA,
    [],
    false,
  )
  static readonly IDENT_ATA = new AddressIdentification(
    AddressIdentificationId.IDENT_ATA,
    () => $t('Ident.'),
    4,
    Country.ATA,
    [],
    false,
  )
  static readonly IDENT_ATG = new AddressIdentification(
    AddressIdentificationId.IDENT_ATG,
    () => $t('Ident.'),
    4,
    Country.ATG,
    [],
    false,
  )
  static readonly IDENT_ARG = new AddressIdentification(
    AddressIdentificationId.IDENT_ARG,
    () => $t('Ident.'),
    4,
    Country.ARG,
    [],
    false,
  )
  static readonly IDENT_ARM = new AddressIdentification(
    AddressIdentificationId.IDENT_ARM,
    () => $t('Ident.'),
    4,
    Country.ARM,
    [],
    false,
  )
  static readonly IDENT_ABW = new AddressIdentification(
    AddressIdentificationId.IDENT_ABW,
    () => $t('Ident.'),
    4,
    Country.ABW,
    [],
    false,
  )
  static readonly IDENT_AUS = new AddressIdentification(
    AddressIdentificationId.IDENT_AUS,
    () => $t('Ident.'),
    4,
    Country.AUS,
    [],
    false,
  )
  static readonly IDENT_BHS = new AddressIdentification(
    AddressIdentificationId.IDENT_BHS,
    () => $t('Ident.'),
    4,
    Country.BHS,
    [],
    false,
  )
  static readonly IDENT_BHR = new AddressIdentification(
    AddressIdentificationId.IDENT_BHR,
    () => $t('Ident.'),
    4,
    Country.BHR,
    [],
    false,
  )
  static readonly IDENT_BGD = new AddressIdentification(
    AddressIdentificationId.IDENT_BGD,
    () => $t('Ident.'),
    4,
    Country.BGD,
    [],
    false,
  )
  static readonly IDENT_BRB = new AddressIdentification(
    AddressIdentificationId.IDENT_BRB,
    () => $t('Ident.'),
    4,
    Country.BRB,
    [],
    false,
  )
  static readonly IDENT_BEL = new AddressIdentification(
    AddressIdentificationId.IDENT_BEL,
    () => $t('Ident.'),
    4,
    Country.BEL,
    [],
    false,
  )
  static readonly IDENT_BLZ = new AddressIdentification(
    AddressIdentificationId.IDENT_BLZ,
    () => $t('Ident.'),
    4,
    Country.BLZ,
    [],
    false,
  )
  static readonly IDENT_BLR = new AddressIdentification(
    AddressIdentificationId.IDENT_BLR,
    () => $t('Ident.'),
    4,
    Country.BLR,
    [],
    false,
  )
  static readonly IDENT_BEN = new AddressIdentification(
    AddressIdentificationId.IDENT_BEN,
    () => $t('Ident.'),
    4,
    Country.BEN,
    [],
    false,
  )
  static readonly IDENT_BMU = new AddressIdentification(
    AddressIdentificationId.IDENT_BMU,
    () => $t('Ident.'),
    4,
    Country.BMU,
    [],
    false,
  )
  static readonly IDENT_BTN = new AddressIdentification(
    AddressIdentificationId.IDENT_BTN,
    () => $t('Ident.'),
    4,
    Country.BTN,
    [],
    false,
  )
  static readonly IDENT_BOL = new AddressIdentification(
    AddressIdentificationId.IDENT_BOL,
    () => $t('Ident.'),
    4,
    Country.BOL,
    [],
    false,
  )
  static readonly IDENT_BIH = new AddressIdentification(
    AddressIdentificationId.IDENT_BIH,
    () => $t('Ident.'),
    4,
    Country.BIH,
    [],
    false,
  )
  static readonly IDENT_BWA = new AddressIdentification(
    AddressIdentificationId.IDENT_BWA,
    () => $t('Ident.'),
    4,
    Country.BWA,
    [],
    false,
  )
  static readonly IDENT_BVT = new AddressIdentification(
    AddressIdentificationId.IDENT_BVT,
    () => $t('Ident.'),
    4,
    Country.BVT,
    [],
    false,
  )
  static readonly IDENT_BRA = new AddressIdentification(
    AddressIdentificationId.IDENT_BRA,
    () => $t('Ident.'),
    4,
    Country.BRA,
    [],
    false,
  )
  static readonly IDENT_IOT = new AddressIdentification(
    AddressIdentificationId.IDENT_IOT,
    () => $t('Ident.'),
    4,
    Country.IOT,
    [],
    false,
  )
  static readonly IDENT_VGB = new AddressIdentification(
    AddressIdentificationId.IDENT_VGB,
    () => $t('Ident.'),
    4,
    Country.VGB,
    [],
    false,
  )
  static readonly IDENT_BRN = new AddressIdentification(
    AddressIdentificationId.IDENT_BRN,
    () => $t('Ident.'),
    4,
    Country.BRN,
    [],
    false,
  )
  static readonly IDENT_BGR = new AddressIdentification(
    AddressIdentificationId.IDENT_BGR,
    () => $t('Ident.'),
    4,
    Country.BGR,
    [],
    false,
  )
  static readonly IDENT_BFA = new AddressIdentification(
    AddressIdentificationId.IDENT_BFA,
    () => $t('Ident.'),
    4,
    Country.BFA,
    [],
    false,
  )
  static readonly IDENT_BDI = new AddressIdentification(
    AddressIdentificationId.IDENT_BDI,
    () => $t('Ident.'),
    4,
    Country.BDI,
    [],
    false,
  )
  static readonly IDENT_COK = new AddressIdentification(
    AddressIdentificationId.IDENT_COK,
    () => $t('Ident.'),
    4,
    Country.COK,
    [],
    false,
  )
  static readonly IDENT_CHN = new AddressIdentification(
    AddressIdentificationId.IDENT_CHN,
    () => $t('Ident.'),
    4,
    Country.CHN,
    [],
    false,
  )
  static readonly IDENT_DNK = new AddressIdentification(
    AddressIdentificationId.IDENT_DNK,
    () => $t('Ident.'),
    4,
    Country.DNK,
    [],
    false,
  )
  static readonly IDENT_DMA = new AddressIdentification(
    AddressIdentificationId.IDENT_DMA,
    () => $t('Ident.'),
    4,
    Country.DMA,
    [],
    false,
  )
  static readonly IDENT_DOM = new AddressIdentification(
    AddressIdentificationId.IDENT_DOM,
    () => $t('Ident.'),
    4,
    Country.DOM,
    [],
    false,
  )
  static readonly IDENT_DJI = new AddressIdentification(
    AddressIdentificationId.IDENT_DJI,
    () => $t('Ident.'),
    4,
    Country.DJI,
    [],
    false,
  )
  static readonly IDENT_TCD = new AddressIdentification(
    AddressIdentificationId.IDENT_TCD,
    () => $t('Ident.'),
    4,
    Country.TCD,
    [],
    false,
  )
  static readonly IDENT_EGY = new AddressIdentification(
    AddressIdentificationId.IDENT_EGY,
    () => $t('Ident.'),
    4,
    Country.EGY,
    [],
    false,
  )
  static readonly IDENT_ECU = new AddressIdentification(
    AddressIdentificationId.IDENT_ECU,
    () => $t('Ident.'),
    4,
    Country.ECU,
    [],
    false,
  )
  static readonly IDENT_ERI = new AddressIdentification(
    AddressIdentificationId.IDENT_ERI,
    () => $t('Ident.'),
    4,
    Country.ERI,
    [],
    false,
  )
  static readonly IDENT_EST = new AddressIdentification(
    AddressIdentificationId.IDENT_EST,
    () => $t('Ident.'),
    4,
    Country.EST,
    [],
    false,
  )
  static readonly IDENT_ETH = new AddressIdentification(
    AddressIdentificationId.IDENT_ETH,
    () => $t('Ident.'),
    4,
    Country.ETH,
    [],
    false,
  )
  static readonly IDENT_FRO = new AddressIdentification(
    AddressIdentificationId.IDENT_FRO,
    () => $t('Ident.'),
    4,
    Country.FRO,
    [],
    false,
  )
  static readonly IDENT_FLK = new AddressIdentification(
    AddressIdentificationId.IDENT_FLK,
    () => $t('Ident.'),
    4,
    Country.FLK,
    [],
    false,
  )
  static readonly IDENT_FJI = new AddressIdentification(
    AddressIdentificationId.IDENT_FJI,
    () => $t('Ident.'),
    4,
    Country.FJI,
    [],
    false,
  )
  static readonly IDENT_PHL = new AddressIdentification(
    AddressIdentificationId.IDENT_PHL,
    () => $t('Ident.'),
    4,
    Country.PHL,
    [],
    false,
  )
  static readonly IDENT_FIN = new AddressIdentification(
    AddressIdentificationId.IDENT_FIN,
    () => $t('Ident.'),
    4,
    Country.FIN,
    [],
    false,
  )
  static readonly IDENT_FRA = new AddressIdentification(
    AddressIdentificationId.IDENT_FRA,
    () => $t('Ident.'),
    4,
    Country.FRA,
    [],
    false,
  )
  static readonly IDENT_GAB = new AddressIdentification(
    AddressIdentificationId.IDENT_GAB,
    () => $t('Ident.'),
    4,
    Country.GAB,
    [],
    false,
  )
  static readonly IDENT_GMB = new AddressIdentification(
    AddressIdentificationId.IDENT_GMB,
    () => $t('Ident.'),
    4,
    Country.GMB,
    [],
    false,
  )
  static readonly IDENT_GHA = new AddressIdentification(
    AddressIdentificationId.IDENT_GHA,
    () => $t('Ident.'),
    4,
    Country.GHA,
    [],
    false,
  )
  static readonly IDENT_GIB = new AddressIdentification(
    AddressIdentificationId.IDENT_GIB,
    () => $t('Ident.'),
    4,
    Country.GIB,
    [],
    false,
  )
  static readonly IDENT_GRD = new AddressIdentification(
    AddressIdentificationId.IDENT_GRD,
    () => $t('Ident.'),
    4,
    Country.GRD,
    [],
    false,
  )
  static readonly IDENT_GRL = new AddressIdentification(
    AddressIdentificationId.IDENT_GRL,
    () => $t('Ident.'),
    4,
    Country.GRL,
    [],
    false,
  )
  static readonly IDENT_GEO = new AddressIdentification(
    AddressIdentificationId.IDENT_GEO,
    () => $t('Ident.'),
    4,
    Country.GEO,
    [],
    false,
  )
  static readonly IDENT_GUM = new AddressIdentification(
    AddressIdentificationId.IDENT_GUM,
    () => $t('Ident.'),
    4,
    Country.GUM,
    [],
    false,
  )
  static readonly IDENT_GTM = new AddressIdentification(
    AddressIdentificationId.IDENT_GTM,
    () => $t('Ident.'),
    4,
    Country.GTM,
    [],
    false,
  )
  static readonly IDENT_GIN = new AddressIdentification(
    AddressIdentificationId.IDENT_GIN,
    () => $t('Ident.'),
    4,
    Country.GIN,
    [],
    false,
  )
  static readonly IDENT_GNB = new AddressIdentification(
    AddressIdentificationId.IDENT_GNB,
    () => $t('Ident.'),
    4,
    Country.GNB,
    [],
    false,
  )
  static readonly IDENT_GUY = new AddressIdentification(
    AddressIdentificationId.IDENT_GUY,
    () => $t('Ident.'),
    4,
    Country.GUY,
    [],
    false,
  )
  static readonly IDENT_HTI = new AddressIdentification(
    AddressIdentificationId.IDENT_HTI,
    () => $t('Ident.'),
    4,
    Country.HTI,
    [],
    false,
  )
  static readonly IDENT_HMD = new AddressIdentification(
    AddressIdentificationId.IDENT_HMD,
    () => $t('Ident.'),
    4,
    Country.HMD,
    [],
    false,
  )
  static readonly IDENT_HND = new AddressIdentification(
    AddressIdentificationId.IDENT_HND,
    () => $t('Ident.'),
    4,
    Country.HND,
    [],
    false,
  )
  static readonly IDENT_HKG = new AddressIdentification(
    AddressIdentificationId.IDENT_HKG,
    () => $t('Ident.'),
    4,
    Country.HKG,
    [],
    false,
  )
  static readonly IDENT_CHL = new AddressIdentification(
    AddressIdentificationId.IDENT_CHL,
    () => $t('Ident.'),
    4,
    Country.CHL,
    [],
    false,
  )
  static readonly IDENT_HRV = new AddressIdentification(
    AddressIdentificationId.IDENT_HRV,
    () => $t('Ident.'),
    4,
    Country.HRV,
    [],
    false,
  )
  static readonly IDENT_IND = new AddressIdentification(
    AddressIdentificationId.IDENT_IND,
    () => $t('Ident.'),
    4,
    Country.IND,
    [],
    false,
  )
  static readonly IDENT_IDN = new AddressIdentification(
    AddressIdentificationId.IDENT_IDN,
    () => $t('Ident.'),
    4,
    Country.IDN,
    [],
    false,
  )
  static readonly IDENT_IRQ = new AddressIdentification(
    AddressIdentificationId.IDENT_IRQ,
    () => $t('Ident.'),
    4,
    Country.IRQ,
    [],
    false,
  )
  static readonly IDENT_IRN = new AddressIdentification(
    AddressIdentificationId.IDENT_IRN,
    () => $t('Ident.'),
    4,
    Country.IRN,
    [],
    false,
  )
  static readonly IDENT_IRL = new AddressIdentification(
    AddressIdentificationId.IDENT_IRL,
    () => $t('Ident.'),
    4,
    Country.IRL,
    [],
    false,
  )
  static readonly IDENT_ISL = new AddressIdentification(
    AddressIdentificationId.IDENT_ISL,
    () => $t('Ident.'),
    4,
    Country.ISL,
    [],
    false,
  )
  static readonly IDENT_ITA = new AddressIdentification(
    AddressIdentificationId.IDENT_ITA,
    () => $t('Ident.'),
    4,
    Country.ITA,
    [],
    false,
  )
  static readonly IDENT_ISR = new AddressIdentification(
    AddressIdentificationId.IDENT_ISR,
    () => $t('Ident.'),
    4,
    Country.ISR,
    [],
    false,
  )
  static readonly IDENT_JAM = new AddressIdentification(
    AddressIdentificationId.IDENT_JAM,
    () => $t('Ident.'),
    4,
    Country.JAM,
    [],
    false,
  )
  static readonly IDENT_JPN = new AddressIdentification(
    AddressIdentificationId.IDENT_JPN,
    () => $t('Ident.'),
    4,
    Country.JPN,
    [],
    false,
  )
  static readonly IDENT_YEM = new AddressIdentification(
    AddressIdentificationId.IDENT_YEM,
    () => $t('Ident.'),
    4,
    Country.YEM,
    [],
    false,
  )
  static readonly IDENT_ZAF = new AddressIdentification(
    AddressIdentificationId.IDENT_ZAF,
    () => $t('Ident.'),
    4,
    Country.ZAF,
    [],
    false,
  )
  static readonly IDENT_SGS = new AddressIdentification(
    AddressIdentificationId.IDENT_SGS,
    () => $t('Ident.'),
    4,
    Country.SGS,
    [],
    false,
  )
  static readonly IDENT_JOR = new AddressIdentification(
    AddressIdentificationId.IDENT_JOR,
    () => $t('Ident.'),
    4,
    Country.JOR,
    [],
    false,
  )
  static readonly IDENT_CYM = new AddressIdentification(
    AddressIdentificationId.IDENT_CYM,
    () => $t('Ident.'),
    4,
    Country.CYM,
    [],
    false,
  )
  static readonly IDENT_KHM = new AddressIdentification(
    AddressIdentificationId.IDENT_KHM,
    () => $t('Ident.'),
    4,
    Country.KHM,
    [],
    false,
  )
  static readonly IDENT_CMR = new AddressIdentification(
    AddressIdentificationId.IDENT_CMR,
    () => $t('Ident.'),
    4,
    Country.CMR,
    [],
    false,
  )
  static readonly IDENT_CAN = new AddressIdentification(
    AddressIdentificationId.IDENT_CAN,
    () => $t('Ident.'),
    4,
    Country.CAN,
    [],
    false,
  )
  static readonly IDENT_CPV = new AddressIdentification(
    AddressIdentificationId.IDENT_CPV,
    () => $t('Ident.'),
    4,
    Country.CPV,
    [],
    false,
  )
  static readonly IDENT_QAT = new AddressIdentification(
    AddressIdentificationId.IDENT_QAT,
    () => $t('Ident.'),
    4,
    Country.QAT,
    [],
    false,
  )
  static readonly IDENT_KAZ = new AddressIdentification(
    AddressIdentificationId.IDENT_KAZ,
    () => $t('Ident.'),
    4,
    Country.KAZ,
    [],
    false,
  )
  static readonly IDENT_KEN = new AddressIdentification(
    AddressIdentificationId.IDENT_KEN,
    () => $t('Ident.'),
    4,
    Country.KEN,
    [],
    false,
  )
  static readonly IDENT_KIR = new AddressIdentification(
    AddressIdentificationId.IDENT_KIR,
    () => $t('Ident.'),
    4,
    Country.KIR,
    [],
    false,
  )
  static readonly IDENT_CCK = new AddressIdentification(
    AddressIdentificationId.IDENT_CCK,
    () => $t('Ident.'),
    4,
    Country.CCK,
    [],
    false,
  )
  static readonly IDENT_COL = new AddressIdentification(
    AddressIdentificationId.IDENT_COL,
    () => $t('Ident.'),
    4,
    Country.COL,
    [],
    false,
  )
  static readonly IDENT_COM = new AddressIdentification(
    AddressIdentificationId.IDENT_COM,
    () => $t('Ident.'),
    4,
    Country.COM,
    [],
    false,
  )
  static readonly IDENT_COG = new AddressIdentification(
    AddressIdentificationId.IDENT_COG,
    () => $t('Ident.'),
    4,
    Country.COG,
    [],
    false,
  )
  static readonly IDENT_COD = new AddressIdentification(
    AddressIdentificationId.IDENT_COD,
    () => $t('Ident.'),
    4,
    Country.COD,
    [],
    false,
  )
  static readonly IDENT_PRK = new AddressIdentification(
    AddressIdentificationId.IDENT_PRK,
    () => $t('Ident.'),
    4,
    Country.PRK,
    [],
    false,
  )
  static readonly IDENT_KOR = new AddressIdentification(
    AddressIdentificationId.IDENT_KOR,
    () => $t('Ident.'),
    4,
    Country.KOR,
    [],
    false,
  )
  static readonly IDENT_CUB = new AddressIdentification(
    AddressIdentificationId.IDENT_CUB,
    () => $t('Ident.'),
    4,
    Country.CUB,
    [],
    false,
  )
  static readonly IDENT_KWT = new AddressIdentification(
    AddressIdentificationId.IDENT_KWT,
    () => $t('Ident.'),
    4,
    Country.KWT,
    [],
    false,
  )
  static readonly IDENT_CYP = new AddressIdentification(
    AddressIdentificationId.IDENT_CYP,
    () => $t('Ident.'),
    4,
    Country.CYP,
    [],
    false,
  )
  static readonly IDENT_KGZ = new AddressIdentification(
    AddressIdentificationId.IDENT_KGZ,
    () => $t('Ident.'),
    4,
    Country.KGZ,
    [],
    false,
  )
  static readonly IDENT_LAO = new AddressIdentification(
    AddressIdentificationId.IDENT_LAO,
    () => $t('Ident.'),
    4,
    Country.LAO,
    [],
    false,
  )
  static readonly IDENT_LSO = new AddressIdentification(
    AddressIdentificationId.IDENT_LSO,
    () => $t('Ident.'),
    4,
    Country.LSO,
    [],
    false,
  )
  static readonly IDENT_LBN = new AddressIdentification(
    AddressIdentificationId.IDENT_LBN,
    () => $t('Ident.'),
    4,
    Country.LBN,
    [],
    false,
  )
  static readonly IDENT_LBR = new AddressIdentification(
    AddressIdentificationId.IDENT_LBR,
    () => $t('Ident.'),
    4,
    Country.LBR,
    [],
    false,
  )
  static readonly IDENT_LBY = new AddressIdentification(
    AddressIdentificationId.IDENT_LBY,
    () => $t('Ident.'),
    4,
    Country.LBY,
    [],
    false,
  )
  static readonly IDENT_LIE = new AddressIdentification(
    AddressIdentificationId.IDENT_LIE,
    () => $t('Ident.'),
    4,
    Country.LIE,
    [],
    false,
  )
  static readonly IDENT_LTU = new AddressIdentification(
    AddressIdentificationId.IDENT_LTU,
    () => $t('Ident.'),
    4,
    Country.LTU,
    [],
    false,
  )
  static readonly IDENT_LVA = new AddressIdentification(
    AddressIdentificationId.IDENT_LVA,
    () => $t('Ident.'),
    4,
    Country.LVA,
    [],
    false,
  )
  static readonly IDENT_LUX = new AddressIdentification(
    AddressIdentificationId.IDENT_LUX,
    () => $t('Ident.'),
    4,
    Country.LUX,
    [],
    false,
  )
  static readonly IDENT_MAC = new AddressIdentification(
    AddressIdentificationId.IDENT_MAC,
    () => $t('Ident.'),
    4,
    Country.MAC,
    [],
    false,
  )
  static readonly IDENT_MDG = new AddressIdentification(
    AddressIdentificationId.IDENT_MDG,
    () => $t('Ident.'),
    4,
    Country.MDG,
    [],
    false,
  )
  static readonly IDENT_MKD = new AddressIdentification(
    AddressIdentificationId.IDENT_MKD,
    () => $t('Ident.'),
    4,
    Country.MKD,
    [],
    false,
  )
  static readonly IDENT_MYS = new AddressIdentification(
    AddressIdentificationId.IDENT_MYS,
    () => $t('Ident.'),
    4,
    Country.MYS,
    [],
    false,
  )
  static readonly IDENT_MWI = new AddressIdentification(
    AddressIdentificationId.IDENT_MWI,
    () => $t('Ident.'),
    4,
    Country.MWI,
    [],
    false,
  )
  static readonly IDENT_MDV = new AddressIdentification(
    AddressIdentificationId.IDENT_MDV,
    () => $t('Ident.'),
    4,
    Country.MDV,
    [],
    false,
  )
  static readonly IDENT_MLI = new AddressIdentification(
    AddressIdentificationId.IDENT_MLI,
    () => $t('Ident.'),
    4,
    Country.MLI,
    [],
    false,
  )
  static readonly IDENT_MLT = new AddressIdentification(
    AddressIdentificationId.IDENT_MLT,
    () => $t('Ident.'),
    4,
    Country.MLT,
    [],
    false,
  )
  static readonly IDENT_MAR = new AddressIdentification(
    AddressIdentificationId.IDENT_MAR,
    () => $t('Ident.'),
    4,
    Country.MAR,
    [],
    false,
  )
  static readonly IDENT_MHL = new AddressIdentification(
    AddressIdentificationId.IDENT_MHL,
    () => $t('Ident.'),
    4,
    Country.MHL,
    [],
    false,
  )
  static readonly IDENT_MUS = new AddressIdentification(
    AddressIdentificationId.IDENT_MUS,
    () => $t('Ident.'),
    4,
    Country.MUS,
    [],
    false,
  )
  static readonly IDENT_MRT = new AddressIdentification(
    AddressIdentificationId.IDENT_MRT,
    () => $t('Ident.'),
    4,
    Country.MRT,
    [],
    false,
  )
  static readonly IDENT_UMI = new AddressIdentification(
    AddressIdentificationId.IDENT_UMI,
    () => $t('Ident.'),
    4,
    Country.UMI,
    [],
    false,
  )
  static readonly IDENT_MEX = new AddressIdentification(
    AddressIdentificationId.IDENT_MEX,
    () => $t('Ident.'),
    4,
    Country.MEX,
    [],
    false,
  )
  static readonly IDENT_FSM = new AddressIdentification(
    AddressIdentificationId.IDENT_FSM,
    () => $t('Ident.'),
    4,
    Country.FSM,
    [],
    false,
  )
  static readonly IDENT_MDA = new AddressIdentification(
    AddressIdentificationId.IDENT_MDA,
    () => $t('Ident.'),
    4,
    Country.MDA,
    [],
    false,
  )
  static readonly IDENT_MCO = new AddressIdentification(
    AddressIdentificationId.IDENT_MCO,
    () => $t('Ident.'),
    4,
    Country.MCO,
    [],
    false,
  )
  static readonly IDENT_MNG = new AddressIdentification(
    AddressIdentificationId.IDENT_MNG,
    () => $t('Ident.'),
    4,
    Country.MNG,
    [],
    false,
  )
  static readonly IDENT_MSR = new AddressIdentification(
    AddressIdentificationId.IDENT_MSR,
    () => $t('Ident.'),
    4,
    Country.MSR,
    [],
    false,
  )
  static readonly IDENT_MOZ = new AddressIdentification(
    AddressIdentificationId.IDENT_MOZ,
    () => $t('Ident.'),
    4,
    Country.MOZ,
    [],
    false,
  )
  static readonly IDENT_MMR = new AddressIdentification(
    AddressIdentificationId.IDENT_MMR,
    () => $t('Ident.'),
    4,
    Country.MMR,
    [],
    false,
  )
  static readonly IDENT_NAM = new AddressIdentification(
    AddressIdentificationId.IDENT_NAM,
    () => $t('Ident.'),
    4,
    Country.NAM,
    [],
    false,
  )
  static readonly IDENT_NRU = new AddressIdentification(
    AddressIdentificationId.IDENT_NRU,
    () => $t('Ident.'),
    4,
    Country.NRU,
    [],
    false,
  )
  static readonly IDENT_DEU = new AddressIdentification(
    AddressIdentificationId.IDENT_DEU,
    () => $t('Ident.'),
    4,
    Country.DEU,
    [],
    false,
  )
  static readonly IDENT_NPL = new AddressIdentification(
    AddressIdentificationId.IDENT_NPL,
    () => $t('Ident.'),
    4,
    Country.NPL,
    [],
    false,
  )
  static readonly IDENT_NER = new AddressIdentification(
    AddressIdentificationId.IDENT_NER,
    () => $t('Ident.'),
    4,
    Country.NER,
    [],
    false,
  )
  static readonly IDENT_NGA = new AddressIdentification(
    AddressIdentificationId.IDENT_NGA,
    () => $t('Ident.'),
    4,
    Country.NGA,
    [],
    false,
  )
  static readonly IDENT_NIC = new AddressIdentification(
    AddressIdentificationId.IDENT_NIC,
    () => $t('Ident.'),
    4,
    Country.NIC,
    [],
    false,
  )
  static readonly IDENT_NIU = new AddressIdentification(
    AddressIdentificationId.IDENT_NIU,
    () => $t('Ident.'),
    4,
    Country.NIU,
    [],
    false,
  )
  static readonly IDENT_NLD = new AddressIdentification(
    AddressIdentificationId.IDENT_NLD,
    () => $t('Ident.'),
    4,
    Country.NLD,
    [],
    false,
  )
  static readonly IDENT_NFK = new AddressIdentification(
    AddressIdentificationId.IDENT_NFK,
    () => $t('Ident.'),
    4,
    Country.NFK,
    [],
    false,
  )
  static readonly IDENT_NOR = new AddressIdentification(
    AddressIdentificationId.IDENT_NOR,
    () => $t('Ident.'),
    4,
    Country.NOR,
    [],
    false,
  )
  static readonly IDENT_NZL = new AddressIdentification(
    AddressIdentificationId.IDENT_NZL,
    () => $t('Ident.'),
    4,
    Country.NZL,
    [],
    false,
  )
  static readonly IDENT_OMN = new AddressIdentification(
    AddressIdentificationId.IDENT_OMN,
    () => $t('Ident.'),
    4,
    Country.OMN,
    [],
    false,
  )
  static readonly IDENT_PAK = new AddressIdentification(
    AddressIdentificationId.IDENT_PAK,
    () => $t('Ident.'),
    4,
    Country.PAK,
    [],
    false,
  )
  static readonly IDENT_PLW = new AddressIdentification(
    AddressIdentificationId.IDENT_PLW,
    () => $t('Ident.'),
    4,
    Country.PLW,
    [],
    false,
  )
  static readonly IDENT_PAN = new AddressIdentification(
    AddressIdentificationId.IDENT_PAN,
    () => $t('Ident.'),
    4,
    Country.PAN,
    [],
    false,
  )
  static readonly IDENT_PNG = new AddressIdentification(
    AddressIdentificationId.IDENT_PNG,
    () => $t('Ident.'),
    4,
    Country.PNG,
    [],
    false,
  )
  static readonly IDENT_PRY = new AddressIdentification(
    AddressIdentificationId.IDENT_PRY,
    () => $t('Ident.'),
    4,
    Country.PRY,
    [],
    false,
  )
  static readonly IDENT_PER = new AddressIdentification(
    AddressIdentificationId.IDENT_PER,
    () => $t('Ident.'),
    4,
    Country.PER,
    [],
    false,
  )
  static readonly IDENT_PCN = new AddressIdentification(
    AddressIdentificationId.IDENT_PCN,
    () => $t('Ident.'),
    4,
    Country.PCN,
    [],
    false,
  )
  static readonly IDENT_CIV = new AddressIdentification(
    AddressIdentificationId.IDENT_CIV,
    () => $t('Ident.'),
    4,
    Country.CIV,
    [],
    false,
  )
  static readonly IDENT_POL = new AddressIdentification(
    AddressIdentificationId.IDENT_POL,
    () => $t('Ident.'),
    4,
    Country.POL,
    [],
    false,
  )
  static readonly IDENT_PRI = new AddressIdentification(
    AddressIdentificationId.IDENT_PRI,
    () => $t('Ident.'),
    4,
    Country.PRI,
    [],
    false,
  )
  static readonly IDENT_PRT = new AddressIdentification(
    AddressIdentificationId.IDENT_PRT,
    () => $t('Ident.'),
    4,
    Country.PRT,
    [],
    false,
  )
  static readonly IDENT_AUT = new AddressIdentification(
    AddressIdentificationId.IDENT_AUT,
    () => $t('Ident.'),
    4,
    Country.AUT,
    [],
    false,
  )
  static readonly IDENT_GNQ = new AddressIdentification(
    AddressIdentificationId.IDENT_GNQ,
    () => $t('Ident.'),
    4,
    Country.GNQ,
    [],
    false,
  )
  static readonly IDENT_RUS = new AddressIdentification(
    AddressIdentificationId.IDENT_RUS,
    () => $t('Ident.'),
    4,
    Country.RUS,
    [],
    false,
  )
  static readonly IDENT_RWA = new AddressIdentification(
    AddressIdentificationId.IDENT_RWA,
    () => $t('Ident.'),
    4,
    Country.RWA,
    [],
    false,
  )
  static readonly IDENT_GRC = new AddressIdentification(
    AddressIdentificationId.IDENT_GRC,
    () => $t('Ident.'),
    4,
    Country.GRC,
    [],
    false,
  )
  static readonly IDENT_SLV = new AddressIdentification(
    AddressIdentificationId.IDENT_SLV,
    () => $t('Ident.'),
    4,
    Country.SLV,
    [],
    false,
  )
  static readonly IDENT_WSM = new AddressIdentification(
    AddressIdentificationId.IDENT_WSM,
    () => $t('Ident.'),
    4,
    Country.WSM,
    [],
    false,
  )
  static readonly IDENT_SMR = new AddressIdentification(
    AddressIdentificationId.IDENT_SMR,
    () => $t('Ident.'),
    4,
    Country.SMR,
    [],
    false,
  )
  static readonly IDENT_SAU = new AddressIdentification(
    AddressIdentificationId.IDENT_SAU,
    () => $t('Ident.'),
    4,
    Country.SAU,
    [],
    false,
  )
  static readonly IDENT_SEN = new AddressIdentification(
    AddressIdentificationId.IDENT_SEN,
    () => $t('Ident.'),
    4,
    Country.SEN,
    [],
    false,
  )
  static readonly IDENT_MNP = new AddressIdentification(
    AddressIdentificationId.IDENT_MNP,
    () => $t('Ident.'),
    4,
    Country.MNP,
    [],
    false,
  )
  static readonly IDENT_SYC = new AddressIdentification(
    AddressIdentificationId.IDENT_SYC,
    () => $t('Ident.'),
    4,
    Country.SYC,
    [],
    false,
  )
  static readonly IDENT_SLE = new AddressIdentification(
    AddressIdentificationId.IDENT_SLE,
    () => $t('Ident.'),
    4,
    Country.SLE,
    [],
    false,
  )
  static readonly IDENT_SGP = new AddressIdentification(
    AddressIdentificationId.IDENT_SGP,
    () => $t('Ident.'),
    4,
    Country.SGP,
    [],
    false,
  )
  static readonly IDENT_SVN = new AddressIdentification(
    AddressIdentificationId.IDENT_SVN,
    () => $t('Ident.'),
    4,
    Country.SVN,
    [],
    false,
  )
  static readonly IDENT_SOM = new AddressIdentification(
    AddressIdentificationId.IDENT_SOM,
    () => $t('Ident.'),
    4,
    Country.SOM,
    [],
    false,
  )
  static readonly IDENT_ARE = new AddressIdentification(
    AddressIdentificationId.IDENT_ARE,
    () => $t('Ident.'),
    4,
    Country.ARE,
    [],
    false,
  )
  static readonly IDENT_LKA = new AddressIdentification(
    AddressIdentificationId.IDENT_LKA,
    () => $t('Ident.'),
    4,
    Country.LKA,
    [],
    false,
  )
  static readonly IDENT_CAF = new AddressIdentification(
    AddressIdentificationId.IDENT_CAF,
    () => $t('Ident.'),
    4,
    Country.CAF,
    [],
    false,
  )
  static readonly IDENT_SDN = new AddressIdentification(
    AddressIdentificationId.IDENT_SDN,
    () => $t('Ident.'),
    4,
    Country.SDN,
    [],
    false,
  )
  static readonly IDENT_SUR = new AddressIdentification(
    AddressIdentificationId.IDENT_SUR,
    () => $t('Ident.'),
    4,
    Country.SUR,
    [],
    false,
  )
  static readonly IDENT_SJM = new AddressIdentification(
    AddressIdentificationId.IDENT_SJM,
    () => $t('Ident.'),
    4,
    Country.SJM,
    [],
    false,
  )
  static readonly IDENT_SHN = new AddressIdentification(
    AddressIdentificationId.IDENT_SHN,
    () => $t('Ident.'),
    4,
    Country.SHN,
    [],
    false,
  )
  static readonly IDENT_LCA = new AddressIdentification(
    AddressIdentificationId.IDENT_LCA,
    () => $t('Ident.'),
    4,
    Country.LCA,
    [],
    false,
  )
  static readonly IDENT_KNA = new AddressIdentification(
    AddressIdentificationId.IDENT_KNA,
    () => $t('Ident.'),
    4,
    Country.KNA,
    [],
    false,
  )
  static readonly IDENT_STP = new AddressIdentification(
    AddressIdentificationId.IDENT_STP,
    () => $t('Ident.'),
    4,
    Country.STP,
    [],
    false,
  )
  static readonly IDENT_VCT = new AddressIdentification(
    AddressIdentificationId.IDENT_VCT,
    () => $t('Ident.'),
    4,
    Country.VCT,
    [],
    false,
  )
  static readonly IDENT_SWZ = new AddressIdentification(
    AddressIdentificationId.IDENT_SWZ,
    () => $t('Ident.'),
    4,
    Country.SWZ,
    [],
    false,
  )
  static readonly IDENT_SYR = new AddressIdentification(
    AddressIdentificationId.IDENT_SYR,
    () => $t('Ident.'),
    4,
    Country.SYR,
    [],
    false,
  )
  static readonly IDENT_SLB = new AddressIdentification(
    AddressIdentificationId.IDENT_SLB,
    () => $t('Ident.'),
    4,
    Country.SLB,
    [],
    false,
  )
  static readonly IDENT_ESP = new AddressIdentification(
    AddressIdentificationId.IDENT_ESP,
    () => $t('Ident.'),
    4,
    Country.ESP,
    [],
    false,
  )
  static readonly IDENT_SWE = new AddressIdentification(
    AddressIdentificationId.IDENT_SWE,
    () => $t('Ident.'),
    4,
    Country.SWE,
    [],
    false,
  )
  static readonly IDENT_CHE = new AddressIdentification(
    AddressIdentificationId.IDENT_CHE,
    () => $t('Ident.'),
    4,
    Country.CHE,
    [],
    false,
  )
  static readonly IDENT_TJK = new AddressIdentification(
    AddressIdentificationId.IDENT_TJK,
    () => $t('Ident.'),
    4,
    Country.TJK,
    [],
    false,
  )
  static readonly IDENT_TZA = new AddressIdentification(
    AddressIdentificationId.IDENT_TZA,
    () => $t('Ident.'),
    4,
    Country.TZA,
    [],
    false,
  )
  static readonly IDENT_THA = new AddressIdentification(
    AddressIdentificationId.IDENT_THA,
    () => $t('Ident.'),
    4,
    Country.THA,
    [],
    false,
  )
  static readonly IDENT_TWN = new AddressIdentification(
    AddressIdentificationId.IDENT_TWN,
    () => $t('Ident.'),
    4,
    Country.TWN,
    [],
    false,
  )
  static readonly IDENT_TGO = new AddressIdentification(
    AddressIdentificationId.IDENT_TGO,
    () => $t('Ident.'),
    4,
    Country.TGO,
    [],
    false,
  )
  static readonly IDENT_TKL = new AddressIdentification(
    AddressIdentificationId.IDENT_TKL,
    () => $t('Ident.'),
    4,
    Country.TKL,
    [],
    false,
  )
  static readonly IDENT_TON = new AddressIdentification(
    AddressIdentificationId.IDENT_TON,
    () => $t('Ident.'),
    4,
    Country.TON,
    [],
    false,
  )
  static readonly IDENT_TTO = new AddressIdentification(
    AddressIdentificationId.IDENT_TTO,
    () => $t('Ident.'),
    4,
    Country.TTO,
    [],
    false,
  )
  static readonly IDENT_TUN = new AddressIdentification(
    AddressIdentificationId.IDENT_TUN,
    () => $t('Ident.'),
    4,
    Country.TUN,
    [],
    false,
  )
  static readonly IDENT_TUR = new AddressIdentification(
    AddressIdentificationId.IDENT_TUR,
    () => $t('Ident.'),
    4,
    Country.TUR,
    [],
    false,
  )
  static readonly IDENT_TKM = new AddressIdentification(
    AddressIdentificationId.IDENT_TKM,
    () => $t('Ident.'),
    4,
    Country.TKM,
    [],
    false,
  )
  static readonly IDENT_TCA = new AddressIdentification(
    AddressIdentificationId.IDENT_TCA,
    () => $t('Ident.'),
    4,
    Country.TCA,
    [],
    false,
  )
  static readonly IDENT_TUV = new AddressIdentification(
    AddressIdentificationId.IDENT_TUV,
    () => $t('Ident.'),
    4,
    Country.TUV,
    [],
    false,
  )
  static readonly IDENT_UGA = new AddressIdentification(
    AddressIdentificationId.IDENT_UGA,
    () => $t('Ident.'),
    4,
    Country.UGA,
    [],
    false,
  )
  static readonly IDENT_UKR = new AddressIdentification(
    AddressIdentificationId.IDENT_UKR,
    () => $t('Ident.'),
    4,
    Country.UKR,
    [],
    false,
  )
  static readonly IDENT_URY = new AddressIdentification(
    AddressIdentificationId.IDENT_URY,
    () => $t('Ident.'),
    4,
    Country.URY,
    [],
    false,
  )
  static readonly IDENT_UZB = new AddressIdentification(
    AddressIdentificationId.IDENT_UZB,
    () => $t('Ident.'),
    4,
    Country.UZB,
    [],
    false,
  )
  static readonly IDENT_CXR = new AddressIdentification(
    AddressIdentificationId.IDENT_CXR,
    () => $t('Ident.'),
    4,
    Country.CXR,
    [],
    false,
  )
  static readonly IDENT_VUT = new AddressIdentification(
    AddressIdentificationId.IDENT_VUT,
    () => $t('Ident.'),
    4,
    Country.VUT,
    [],
    false,
  )
  static readonly IDENT_VAT = new AddressIdentification(
    AddressIdentificationId.IDENT_VAT,
    () => $t('Ident.'),
    4,
    Country.VAT,
    [],
    false,
  )
  static readonly IDENT_VEN = new AddressIdentification(
    AddressIdentificationId.IDENT_VEN,
    () => $t('Ident.'),
    4,
    Country.VEN,
    [],
    false,
  )
  static readonly IDENT_VNM = new AddressIdentification(
    AddressIdentificationId.IDENT_VNM,
    () => $t('Ident.'),
    4,
    Country.VNM,
    [],
    false,
  )
  static readonly IDENT_TLS = new AddressIdentification(
    AddressIdentificationId.IDENT_TLS,
    () => $t('Ident.'),
    4,
    Country.TLS,
    [],
    false,
  )
  static readonly IDENT_ZMB = new AddressIdentification(
    AddressIdentificationId.IDENT_ZMB,
    () => $t('Ident.'),
    4,
    Country.ZMB,
    [],
    false,
  )
  static readonly IDENT_ESH = new AddressIdentification(
    AddressIdentificationId.IDENT_ESH,
    () => $t('Ident.'),
    4,
    Country.ESH,
    [],
    false,
  )
  static readonly IDENT_ZWE = new AddressIdentification(
    AddressIdentificationId.IDENT_ZWE,
    () => $t('Ident.'),
    4,
    Country.ZWE,
    [],
    false,
  )
  static readonly IDENT_MNE = new AddressIdentification(
    AddressIdentificationId.IDENT_MNE,
    () => $t('Ident.'),
    4,
    Country.MNE,
    [],
    false,
  )
  static readonly IDENT_XKX = new AddressIdentification(
    AddressIdentificationId.IDENT_XKX,
    () => $t('Ident.'),
    4,
    Country.XKX,
    [],
    false,
  )
  static readonly IDENT_SRB = new AddressIdentification(
    AddressIdentificationId.IDENT_SRB,
    () => $t('Ident.'),
    4,
    Country.SRB,
    [],
    false,
  )
  static readonly IDENT_AZE = new AddressIdentification(
    AddressIdentificationId.IDENT_AZE,
    () => $t('Ident.'),
    4,
    Country.AZE,
    [],
    false,
  )
  static readonly IDENT_ALA = new AddressIdentification(
    AddressIdentificationId.IDENT_ALA,
    () => $t('Ident.'),
    4,
    Country.ALA,
    [],
    false,
  )
  static readonly IDENT_BES = new AddressIdentification(
    AddressIdentificationId.IDENT_BES,
    () => $t('Ident.'),
    4,
    Country.BES,
    [],
    false,
  )
  static readonly IDENT_CUW = new AddressIdentification(
    AddressIdentificationId.IDENT_CUW,
    () => $t('Ident.'),
    4,
    Country.CUW,
    [],
    false,
  )
  static readonly IDENT_GUF = new AddressIdentification(
    AddressIdentificationId.IDENT_GUF,
    () => $t('Ident.'),
    4,
    Country.GUF,
    [],
    false,
  )
  static readonly IDENT_PYF = new AddressIdentification(
    AddressIdentificationId.IDENT_PYF,
    () => $t('Ident.'),
    4,
    Country.PYF,
    [],
    false,
  )
  static readonly IDENT_ATF = new AddressIdentification(
    AddressIdentificationId.IDENT_ATF,
    () => $t('Ident.'),
    4,
    Country.ATF,
    [],
    false,
  )
  static readonly IDENT_GLP = new AddressIdentification(
    AddressIdentificationId.IDENT_GLP,
    () => $t('Ident.'),
    4,
    Country.GLP,
    [],
    false,
  )
  static readonly IDENT_GGY = new AddressIdentification(
    AddressIdentificationId.IDENT_GGY,
    () => $t('Ident.'),
    4,
    Country.GGY,
    [],
    false,
  )
  static readonly IDENT_IMN = new AddressIdentification(
    AddressIdentificationId.IDENT_IMN,
    () => $t('Ident.'),
    4,
    Country.IMN,
    [],
    false,
  )
  static readonly IDENT_JEY = new AddressIdentification(
    AddressIdentificationId.IDENT_JEY,
    () => $t('Ident.'),
    4,
    Country.JEY,
    [],
    false,
  )
  static readonly IDENT_MTQ = new AddressIdentification(
    AddressIdentificationId.IDENT_MTQ,
    () => $t('Ident.'),
    4,
    Country.MTQ,
    [],
    false,
  )
  static readonly IDENT_MYT = new AddressIdentification(
    AddressIdentificationId.IDENT_MYT,
    () => $t('Ident.'),
    4,
    Country.MYT,
    [],
    false,
  )
  static readonly IDENT_NCL = new AddressIdentification(
    AddressIdentificationId.IDENT_NCL,
    () => $t('Ident.'),
    4,
    Country.NCL,
    [],
    false,
  )
  static readonly IDENT_PSE = new AddressIdentification(
    AddressIdentificationId.IDENT_PSE,
    () => $t('Ident.'),
    4,
    Country.PSE,
    [],
    false,
  )
  static readonly IDENT_REU = new AddressIdentification(
    AddressIdentificationId.IDENT_REU,
    () => $t('Ident.'),
    4,
    Country.REU,
    [],
    false,
  )
  static readonly IDENT_BLM = new AddressIdentification(
    AddressIdentificationId.IDENT_BLM,
    () => $t('Ident.'),
    4,
    Country.BLM,
    [],
    false,
  )
  static readonly IDENT_MAF = new AddressIdentification(
    AddressIdentificationId.IDENT_MAF,
    () => $t('Ident.'),
    4,
    Country.MAF,
    [],
    false,
  )
  static readonly IDENT_SPM = new AddressIdentification(
    AddressIdentificationId.IDENT_SPM,
    () => $t('Ident.'),
    4,
    Country.SPM,
    [],
    false,
  )
  static readonly IDENT_SXM = new AddressIdentification(
    AddressIdentificationId.IDENT_SXM,
    () => $t('Ident.'),
    4,
    Country.SXM,
    [],
    false,
  )
  static readonly IDENT_SSD = new AddressIdentification(
    AddressIdentificationId.IDENT_SSD,
    () => $t('Ident.'),
    4,
    Country.SSD,
    [],
    false,
  )
  static readonly IDENT_WLF = new AddressIdentification(
    AddressIdentificationId.IDENT_WLF,
    () => $t('Ident.'),
    4,
    Country.WLF,
    [],
    false,
  )
  static readonly IDENT_GBR = new AddressIdentification(
    AddressIdentificationId.IDENT_GBR,
    () => $t('Ident.'),
    4,
    Country.GBR,
    [],
    false,
  )
  static readonly IDENT_CRI = new AddressIdentification(
    AddressIdentificationId.IDENT_CRI,
    () => $t('Ident.'),
    4,
    Country.CRI,
    [],
    false,
  )
  static readonly IDENT_USA = new AddressIdentification(
    AddressIdentificationId.IDENT_USA,
    () => $t('Ident.'),
    4,
    Country.USA,
    [],
    false,
  )
  static readonly ADDITIONAL_ADDRESS_ROU = new AddressIdentification(
    AddressIdentificationId.ADDITIONAL_ADDRESS_ROU,
    () => $t('Details'),
    10,
    Country.ROU,
    [],
    false,
  )
  static readonly JST_NAME_PL = new AddressIdentification(
    AddressIdentificationId.JST_NAME_PL,
    () => $t('JST name'),
    13,
    Country.POL,
    [],
    false,
  )
  static readonly JST_NIP_PL = new AddressIdentification(
    AddressIdentificationId.JST_NIP_PL,
    () => $t('JST NIP'),
    14,
    Country.POL,
    [],
    false,
  )
  static readonly JST_ROLE_PL = new AddressIdentification(
    AddressIdentificationId.JST_ROLE_PL,
    () => $t('JST role'),
    15,
    Country.POL,
    [
      { id: '0', name: '', isNullOption: true },
      { id: '2', name: 'Odbiorca - Recipient' },
      { id: '4', name: 'Dodatkowy nabywca - Additional purchaser' },
      { id: '6', name: 'Dokonujący płatności - Payer' },
      { id: '8', name: 'JST – odbiorca, - Local government unit (LGU) – recipient' },
      { id: '10', name: 'Członek GV – odbiorca, - GV member – recipient' },
      { id: '11', name: 'Pracownik - Employee' },
    ],
    false,
  )
  static readonly COUNTY_ROU = new AddressIdentification(
    AddressIdentificationId.COUNTY_ROU,
    () => $t('County'),
    6,
    Country.ROU,
    [
      { id: '-', name: 'Nu este specificat', isNullOption: true },
      { id: 'AB', name: 'ALBA' },
      { id: 'AR', name: 'ARAD' },
      { id: 'AG', name: 'ARGEȘ' },
      { id: 'BC', name: 'BACĂU' },
      { id: 'BH', name: 'BIHOR' },
      { id: 'BN', name: 'BISTRIȚA-NĂSĂUD' },
      { id: 'BT', name: 'BOTOȘANI' },
      { id: 'BV', name: 'BRAȘOV' },
      { id: 'BR', name: 'BRĂILA' },
      { id: 'BZ', name: 'BUZĂU' },
      { id: 'CS', name: 'CARAȘ-SEVERIN' },
      { id: 'CL', name: 'CĂLĂRAȘI' },
      { id: 'CJ', name: 'CLUJ' },
      { id: 'CT', name: 'CONSTANȚA' },
      { id: 'CV', name: 'COVASNA' },
      { id: 'DB', name: 'DÂMBOVIȚA' },
      { id: 'DJ', name: 'DOLJ' },
      { id: 'GL', name: 'GALAȚI' },
      { id: 'GR', name: 'GIURGIU' },
      { id: 'GJ', name: 'GORJ' },
      { id: 'HR', name: 'HARGHITA' },
      { id: 'HD', name: 'HUNEDOARA' },
      { id: 'IL', name: 'IALOMIȚA' },
      { id: 'IS', name: 'IAȘI' },
      { id: 'IF', name: 'ILFOV' },
      { id: 'MM', name: 'MARAMUREȘ' },
      { id: 'MH', name: 'MEHEDINȚI' },
      { id: 'MS', name: 'MUREȘ' },
      { id: 'NT', name: 'NEAMȚ' },
      { id: 'OT', name: 'OLT' },
      { id: 'PH', name: 'PRAHOVA' },
      { id: 'SM', name: 'SATU MARE' },
      { id: 'SJ', name: 'SĂLAJ' },
      { id: 'SB', name: 'SIBIU' },
      { id: 'SV', name: 'SUCEAVA' },
      { id: 'TR', name: 'TELEORMAN' },
      { id: 'TM', name: 'TIMIȘ' },
      { id: 'TL', name: 'TULCEA' },
      { id: 'VS', name: 'VASLUI' },
      { id: 'VL', name: 'VÂLCEA' },
      { id: 'VN', name: 'VRANCEA' },
      { id: 'B', name: 'MUNICIPIUL BUCUREȘTI' },
    ],
    true,
  )
  static readonly CNP_ROU = new AddressIdentification(
    AddressIdentificationId.CNP_ROU,
    () => $t('CNP'),
    7,
    Country.ROU,
    [],
    false,
  )
  static readonly SECTOR_ROU = new AddressIdentification(
    AddressIdentificationId.SECTOR_ROU,
    () => $t('Sector'),
    8,
    Country.ROU,
    [
      { id: '-', name: '-', isNullOption: true },
      { id: 'SECTOR1', name: 'Sectorul 1' },
      { id: 'SECTOR2', name: 'Sectorul 2' },
      { id: 'SECTOR3', name: 'Sectorul 3' },
      { id: 'SECTOR4', name: 'Sectorul 4' },
      { id: 'SECTOR5', name: 'Sectorul 5' },
      { id: 'SECTOR6', name: 'Sectorul 6' },
    ],
    false,
  )
  static readonly BASIC_CAPITAL_ROU = new AddressIdentification(
    AddressIdentificationId.BASIC_CAPITAL_ROU,
    () => $t('Registered capital'),
    9,
    Country.ROU,
    [],
    false,
  )
  static readonly VAT_EU_NUMBER_HUN = new AddressIdentification(
    AddressIdentificationId.VAT_EU_NUMBER_HUN,
    () => $t('EU VAT'),
    11,
    Country.HUN,
    [],
    false,
  )
  static readonly GROUP_VAT_NUMBER_HUN = new AddressIdentification(
    AddressIdentificationId.GROUP_VAT_NUMBER_HUN,
    () => $t('Group VAT'),
    12,
    Country.HUN,
    [],
    false,
  )
  static readonly IDENT_HUN = new AddressIdentification(
    AddressIdentificationId.IDENT_HUN,
    () => $t('Ident.'),
    4,
    Country.HUN,
    [],
    false,
  )
  static readonly STREET_TYPE_HUN = new AddressIdentification(
    AddressIdentificationId.STREET_TYPE_HUN,
    () => $t('Street type'),
    5,
    Country.HUN,
    [
      { id: '-1', name: 'nincs' },
      { id: '1', name: 'utca' },
      { id: '2', name: 'út' },
      { id: '3', name: 'tér' },
      { id: '16', name: 'körút' },
      { id: '45', name: 'ajándékbolt' },
      { id: '46', name: 'akna' },
      { id: '47', name: 'akna-alsó' },
      { id: '48', name: 'akna-felső' },
      { id: '49', name: 'aknaüzem' },
      { id: '50', name: 'alagsor' },
      { id: '51', name: 'alagút' },
      { id: '52', name: 'alkotóház' },
      { id: '60', name: 'állatésnöv.kert' },
      { id: '61', name: 'állomás' },
      { id: '53', name: 'alsórakpart' },
      { id: '54', name: 'aluljáró' },
      { id: '55', name: 'anyagbánya' },
      { id: '56', name: 'arborétum' },
      { id: '62', name: 'árnyék' },
      { id: '41', name: 'árok' },
      { id: '63', name: 'ártér' },
      { id: '64', name: 'árucsarnok' },
      { id: '65', name: 'árusítóhely' },
      { id: '39', name: 'átjáró' },
      { id: '66', name: 'átkelő' },
      { id: '58', name: 'autópálya' },
      { id: '57', name: 'autóparkoló' },
      { id: '59', name: 'autóút' },
      { id: '69', name: 'bánya' },
      { id: '70', name: 'bányatelep' },
      { id: '71', name: 'bányaüzem' },
      { id: '67', name: 'barakképület' },
      { id: '68', name: 'barlang' },
      { id: '72', name: 'bástya' },
      { id: '73', name: 'bástyája' },
      { id: '74', name: 'bejáró' },
      { id: '75', name: 'bekötőút' },
      { id: '76', name: 'belterület' },
      { id: '77', name: 'bemutatókert' },
      { id: '78', name: 'bemutatóterem' },
      { id: '79', name: 'benzinkút' },
      { id: '80', name: 'betonüzem' },
      { id: '81', name: 'bevásárlóközpont' },
      { id: '82', name: 'bevásárlóudvar' },
      { id: '83', name: 'birtok' },
      { id: '84', name: 'bokor' },
      { id: '85', name: 'bolt' },
      { id: '86', name: 'borházsor' },
      { id: '87', name: 'borozó' },
      { id: '88', name: 'csapás' },
      { id: '92', name: 'csárda' },
      { id: '89', name: 'csarnok' },
      { id: '90', name: 'csarnokrész' },
      { id: '91', name: 'csatorna' },
      { id: '93', name: 'csomópont' },
      { id: '94', name: 'csónakház' },
      { id: '95', name: 'csónakházak' },
      { id: '96', name: 'csónakkikötő' },
      { id: '97', name: 'domb' },
      { id: '98', name: 'dűlő' },
      { id: '99', name: 'dűlők' },
      { id: '35', name: 'dűlősor' },
      { id: '100', name: 'dűlőterület' },
      { id: '4', name: 'dűlőút' },
      { id: '103', name: 'egyéb' },
      { id: '101', name: 'egyetem' },
      { id: '102', name: 'egyetemváros' },
      { id: '104', name: 'elágazás' },
      { id: '105', name: 'emlékpark' },
      { id: '106', name: 'emlékút' },
      { id: '112', name: 'épület' },
      { id: '107', name: 'erdészet' },
      { id: '108', name: 'erdészház' },
      { id: '109', name: 'erdészlak' },
      { id: '110', name: 'erdő' },
      { id: '111', name: 'erdőalja' },
      { id: '5', name: 'erdősor' },
      { id: '113', name: 'farm' },
      { id: '114', name: 'farmertanyák' },
      { id: '6', name: 'fasor' },
      { id: '115', name: 'fasora' },
      { id: '116', name: 'felső' },
      { id: '119', name: 'félsziget' },
      { id: '117', name: 'felüljáró' },
      { id: '118', name: 'fennsík' },
      { id: '120', name: 'főcsatorna' },
      { id: '121', name: 'föld' },
      { id: '122', name: 'főmérnökség' },
      { id: '7', name: 'forduló' },
      { id: '123', name: 'főtér' },
      { id: '125', name: 'főút' },
      { id: '124', name: 'főutca' },
      { id: '126', name: 'főútvonal' },
      { id: '127', name: 'fürdő' },
      { id: '128', name: 'garázs' },
      { id: '129', name: 'garázssor' },
      { id: '8', name: 'gát' },
      { id: '130', name: 'gátfeljáró' },
      { id: '131', name: 'gátőrház' },
      { id: '132', name: 'gátsor' },
      { id: '133', name: 'gépállomás' },
      { id: '134', name: 'gépjavítóüzem' },
      { id: '135', name: 'géppark' },
      { id: '136', name: 'géptelep' },
      { id: '137', name: 'gödör' },
      { id: '138', name: 'gyár' },
      { id: '139', name: 'gyártelep' },
      { id: '140', name: 'gyárváros' },
      { id: '141', name: 'gyümölcsös' },
      { id: '150', name: 'hágó' },
      { id: '142', name: 'hajóállomás' },
      { id: '143', name: 'hajókikötő' },
      { id: '144', name: 'halastavak' },
      { id: '145', name: 'halastó' },
      { id: '146', name: 'határ' },
      { id: '147', name: 'határátkelőhely' },
      { id: '148', name: 'határkirendeltség' },
      { id: '9', name: 'határsor' },
      { id: '149', name: 'határszél' },
      { id: '10', name: 'határút' },
      { id: '151', name: 'ház' },
      { id: '152', name: 'házrész' },
      { id: '153', name: 'hegy' },
      { id: '154', name: 'hegyalja' },
      { id: '155', name: 'hegyhát' },
      { id: '156', name: 'hegyhátdűlő' },
      { id: '157', name: 'hegyhátköz' },
      { id: '158', name: 'hév' },
      { id: '159', name: 'hévállomás' },
      { id: '11', name: 'híd' },
      { id: '160', name: 'hídfő' },
      { id: '161', name: 'homokhát' },
      { id: '162', name: 'horgásztó' },
      { id: '163', name: 'hrsz' },
      { id: '164', name: 'hrsz.' },
      { id: '165', name: 'iparipark' },
      { id: '166', name: 'ipartelep' },
      { id: '167', name: 'iparterület' },
      { id: '168', name: 'iskola' },
      { id: '12', name: 'játszótér' },
      { id: '169', name: 'juhászat' },
      { id: '170', name: 'juhtelep' },
      { id: '171', name: 'kapu' },
      { id: '172', name: 'kastély' },
      { id: '173', name: 'kastélyszálló' },
      { id: '13', name: 'kert' },
      { id: '174', name: 'kertalja' },
      { id: '175', name: 'kertsor' },
      { id: '176', name: 'kertváros' },
      { id: '177', name: 'kerület' },
      { id: '178', name: 'kikötő' },
      { id: '179', name: 'kikötősor' },
      { id: '180', name: 'kilátó' },
      { id: '181', name: 'kioszk' },
      { id: '182', name: 'kiskörút' },
      { id: '183', name: 'kocsiszín' },
      { id: '184', name: 'kolónia' },
      { id: '186', name: 'kör' },
      { id: '187', name: 'körforgalom' },
      { id: '188', name: 'körgyűrű' },
      { id: '189', name: 'körlet' },
      { id: '14', name: 'körönd' },
      { id: '15', name: 'körtér' },
      { id: '190', name: 'körvasútsor' },
      { id: '191', name: 'körzet' },
      { id: '185', name: 'korzó' },
      { id: '17', name: 'köz' },
      { id: '192', name: 'közdülő' },
      { id: '193', name: 'köztemető' },
      { id: '195', name: 'köztér' },
      { id: '194', name: 'közterület' },
      { id: '196', name: 'közút' },
      { id: '201', name: 'külkerület' },
      { id: '202', name: 'kültelek' },
      { id: '204', name: 'kültér' },
      { id: '203', name: 'külterület' },
      { id: '197', name: 'kultúrpark' },
      { id: '198', name: 'kunyhó' },
      { id: '199', name: 'kút' },
      { id: '200', name: 'kútsor' },
      { id: '205', name: 'lakóház' },
      { id: '206', name: 'lakónegyed' },
      { id: '207', name: 'lakópark' },
      { id: '18', name: 'lakótelep' },
      { id: '208', name: 'laktanya' },
      { id: '209', name: 'leágazás' },
      { id: '19', name: 'lejáró' },
      { id: '20', name: 'lejtő' },
      { id: '21', name: 'lépcső' },
      { id: '22', name: 'liget' },
      { id: '210', name: 'major' },
      { id: '211', name: 'malom' },
      { id: '23', name: 'mélyút' },
      { id: '212', name: 'menedékház' },
      { id: '213', name: 'mező' },
      { id: '214', name: 'munkásszálló' },
      { id: '215', name: 'műút' },
      { id: '216', name: 'nagykörút' },
      { id: '217', name: 'népliget' },
      { id: '218', name: 'oldal' },
      { id: '219', name: 'öreghegy' },
      { id: '220', name: 'őrház' },
      { id: '221', name: 'őrházak' },
      { id: '222', name: 'őrházlak' },
      { id: '24', name: 'orom' },
      { id: '25', name: 'országút' },
      { id: '26', name: 'ösvény' },
      { id: '223', name: 'övezet' },
      { id: '224', name: 'pagony' },
      { id: '231', name: 'pálya' },
      { id: '232', name: 'pályaudvar' },
      { id: '27', name: 'park' },
      { id: '225', name: 'parkerdő' },
      { id: '226', name: 'parkja' },
      { id: '227', name: 'parkoló' },
      { id: '228', name: 'parkolótér' },
      { id: '229', name: 'parkutca' },
      { id: '28', name: 'part' },
      { id: '230', name: 'pavilon' },
      { id: '233', name: 'piac' },
      { id: '235', name: 'piaccsarnok' },
      { id: '234', name: 'piactér' },
      { id: '236', name: 'pihenő' },
      { id: '237', name: 'pince' },
      { id: '238', name: 'pincehelyiség' },
      { id: '29', name: 'pincesor' },
      { id: '239', name: 'postafiók' },
      { id: '240', name: 'puszta' },
      { id: '30', name: 'rakpart' },
      { id: '241', name: 'repülőtér' },
      { id: '242', name: 'rész' },
      { id: '243', name: 'rét' },
      { id: '245', name: 'sánc' },
      { id: '244', name: 'sarok' },
      { id: '246', name: 'sávház' },
      { id: '31', name: 'sétány' },
      { id: '32', name: 'sétaút' },
      { id: '44', name: 'sikátor' },
      { id: '247', name: 'sípálya' },
      { id: '33', name: 'sor' },
      { id: '248', name: 'sora' },
      { id: '249', name: 'sóstó' },
      { id: '250', name: 'sportcentrum' },
      { id: '251', name: 'sportcsarnok' },
      { id: '252', name: 'sportpálya' },
      { id: '253', name: 'sporttelep' },
      { id: '254', name: 'sportuszoda' },
      { id: '255', name: 'stadion' },
      { id: '256', name: 'strand' },
      { id: '257', name: 'strandfürdő' },
      { id: '34', name: 'sugárút' },
      { id: '258', name: 'szabadidőközpont' },
      { id: '259', name: 'szabadidőpark' },
      { id: '260', name: 'szállás' },
      { id: '261', name: 'szállások' },
      { id: '263', name: 'szél' },
      { id: '262', name: 'szer' },
      { id: '264', name: 'szérű' },
      { id: '265', name: 'szérűskert' },
      { id: '266', name: 'sziget' },
      { id: '267', name: 'szivattyútelep' },
      { id: '268', name: 'szőlő' },
      { id: '269', name: 'szőlőhegy' },
      { id: '270', name: 'szőlők' },
      { id: '271', name: 'szőlőkalja' },
      { id: '272', name: 'szőlőskert' },
      { id: '273', name: 'szőlősor' },
      { id: '274', name: 'szőlővölgy' },
      { id: '275', name: 'tag' },
      { id: '43', name: 'tanya' },
      { id: '277', name: 'tanyák' },
      { id: '276', name: 'tanyaközpont' },
      { id: '278', name: 'telek' },
      { id: '279', name: 'telep' },
      { id: '280', name: 'telephely' },
      { id: '288', name: 'télikikötő' },
      { id: '281', name: 'temető' },
      { id: '282', name: 'terasz' },
      { id: '36', name: 'tere' },
      { id: '283', name: 'terminál' },
      { id: '284', name: 'terület' },
      { id: '285', name: 'tető' },
      { id: '286', name: 'tetőszint' },
      { id: '287', name: 'tetőtér' },
      { id: '289', name: 'tó' },
      { id: '293', name: 'töltés' },
      { id: '294', name: 'tömb' },
      { id: '290', name: 'tópark' },
      { id: '291', name: 'tópart' },
      { id: '292', name: 'tósétány' },
      { id: '295', name: 'turistaház' },
      { id: '37', name: 'turistaút' },
      { id: '308', name: 'üdülő' },
      { id: '309', name: 'üdülő-part' },
      { id: '310', name: 'üdülő-sor' },
      { id: '311', name: 'üdülő-telep' },
      { id: '312', name: 'üdülőközpont' },
      { id: '42', name: 'üdülőpart' },
      { id: '313', name: 'üdülőtelep' },
      { id: '314', name: 'üdülőterület' },
      { id: '38', name: 'udvar' },
      { id: '296', name: 'ugar' },
      { id: '303', name: 'újtelep' },
      { id: '297', name: 'uradalom' },
      { id: '298', name: 'utak' },
      { id: '299', name: 'utcafront' },
      { id: '302', name: 'utcája' },
      { id: '300', name: 'utcasor' },
      { id: '301', name: 'utcatér' },
      { id: '304', name: 'útfél' },
      { id: '305', name: 'útgyűrű' },
      { id: '40', name: 'útja' },
      { id: '306', name: 'útőrház' },
      { id: '307', name: 'útsor' },
      { id: '315', name: 'üzletház' },
      { id: '316', name: 'üzletközpont' },
      { id: '317', name: 'üzletsor' },
      { id: '318', name: 'vadaskert' },
      { id: '319', name: 'vadászház' },
      { id: '325', name: 'vágóhíd' },
      { id: '326', name: 'vár' },
      { id: '327', name: 'várkerület' },
      { id: '328', name: 'várköz' },
      { id: '329', name: 'vármegy' },
      { id: '330', name: 'város' },
      { id: '331', name: 'városrész' },
      { id: '332', name: 'vásárcsarnok' },
      { id: '333', name: 'vásárpiac' },
      { id: '334', name: 'vásártelep' },
      { id: '335', name: 'vásártér' },
      { id: '320', name: 'vasút' },
      { id: '321', name: 'vasútállomás' },
      { id: '322', name: 'vasútimegálló' },
      { id: '323', name: 'vasútiőrház' },
      { id: '324', name: 'vasútsor' },
      { id: '336', name: 'védgát' },
      { id: '338', name: 'végállomás' },
      { id: '337', name: 'vezetőút' },
      { id: '339', name: 'villasor' },
      { id: '340', name: 'vízitelep' },
      { id: '341', name: 'vízmű' },
      { id: '342', name: 'víztározó' },
      { id: '343', name: 'völgy' },
      { id: '344', name: 'völgysziget' },
      { id: '345', name: 'zárkert' },
      { id: '346', name: 'zsilip' },
      { id: '347', name: 'zug' },
    ],
    false,
  )

  static getByCountryId = (countryId: CountryId): AddressIdentification[] => {
    return AddressIdentification.all().filter((item) => item.country.id === countryId)
  }

  static getByCountryAndIdentNumberOrNull = (
    countryId: CountryId,
    identNumber: number,
  ): AddressIdentification | null => {
    return (
      AddressIdentification.getByCountryId(countryId).find(
        (identification) => identification.identNumber === identNumber,
      ) ?? null
    )
  }

  static getByCountryAndIdentNumber = (
    countryId: CountryId,
    identNumber: number,
  ): AddressIdentification => {
    const addressIdentification = AddressIdentification.getByCountryAndIdentNumberOrNull(
      countryId,
      identNumber,
    )

    if (!addressIdentification) {
      throw new Error(
        'Address identification with identNumber: #' + identNumber + ' has not been found',
      )
    }

    return addressIdentification
  }

  static getByCountryAndIdentNumbers = (
    countryId: CountryId,
    identNumbers: number[],
  ): AddressIdentification[] => {
    let addressIdentifications
    if (identNumbers.length > 0) {
      addressIdentifications = AddressIdentification.getByCountryId(countryId).filter((cif) =>
        identNumbers.includes(cif.identNumber),
      )
    } else {
      addressIdentifications = AddressIdentification.getByCountryId(countryId)
    }

    if (!addressIdentifications) {
      throw new Error('Address identification has not been found')
    }

    return addressIdentifications
  }
}
